module.exports = __webpack_public_path__ + "static/media/text.a900cd97.svg";